var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"p-5 space-y-6 rounded-lg bg-grey-950"},[_c('OverviewSummary',{attrs:{"summary":_vm.summary,"embedded":""}}),_vm._v(" "),_c('OverviewProfileHighlights',{attrs:{"job-offer-data":_vm.jobOfferData,"applicant-data":_vm.applicantData,"wheel-mode":_vm.wheelMode,"embedded":"","stacked":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }